import React, { useEffect } from "react";

export default function LoginFailure() {
    useEffect(() => {
        window.close();
    }, []);

    return <div>Failed to sign in!</div>;
}
